import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Cursor = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Cursor' {...props}>
    <polygon fill='none' stroke='#000' strokeWidth='2' points='6 3 18 14 13 15 16 20.5 13 22 10 16 6 19' />
  </StyledIcon>
);
